"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/portal_error.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalOrderOutOfStockError = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.order.v1.PortalOrderOutOfStockError
 */
class PortalOrderOutOfStockError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string reason = 1;
         */
        this.reason = "";
        /**
         * @generated from field: string domain = 2;
         */
        this.domain = "";
        /**
         * @generated from field: map<string, string> metadata = 3;
         */
        this.metadata = {};
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderOutOfStockError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderOutOfStockError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderOutOfStockError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderOutOfStockError, a, b);
    }
}
exports.PortalOrderOutOfStockError = PortalOrderOutOfStockError;
PortalOrderOutOfStockError.runtime = protobuf_1.proto3;
PortalOrderOutOfStockError.typeName = "spwn.order.v1.PortalOrderOutOfStockError";
PortalOrderOutOfStockError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
//# sourceMappingURL=portal_error_pb.js.map